<template>
  <div>
    <v-row align="center" class="pa-4 mb-2">
      <div>
        <BaseTextField
          v-model="telephoneSearch"
          type-input="number"
          iconButton="mdi-magnify"
          label="Введите номер телефона"
          tooltip="Поиск по телефону"
          @button-click="searchAbonents"
        />
      </div>
      <div>
        <BaseTextField
          v-model="carSearch"
          type-input="string"
          iconButton="mdi-magnify"
          label="Введите номер машины"
          tooltip="Поиск по номеру машины"
          @button-click="searchAbonents()"
        />
      </div>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="roleName === 'admin'"
            color="#4C6C93"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="downloadReportPage"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-arrow-down-bold-box-outline</v-icon>
          </v-btn>
        </template>
        <span>Скачать отчёт на странице</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#4C6C93"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="updateListAbonents"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-reload</v-icon>
          </v-btn>
        </template>
        <span>Обновить</span>
      </v-tooltip>
    </v-row>
    <v-data-table
      class="table"
      :headers="headersTable"
      :items="responseAbonents"
      :options.sync="options"
      :server-items-length="totalAccounts"
      :items-per-page="20"
      :footer-props="{
        'items-per-page-options': [5, 15, 20, 50, 100],
        showFirstLastPage: true
      }"
    >
      <template v-slot:header.telephone>
        Телефон
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              text
              x-large
              style="cursor: default;"
              class="btn__icon pa-0 ml-4"
              width="18"
              height="18"
            >
              <v-icon size="x-large">mdi-chat-question-outline</v-icon>
            </v-btn>
          </template>
          <span>Номер телефона можно скопировать правой кнопкой мыши</span>
        </v-tooltip>
      </template>
      <template v-slot:item.address="{ item }">
        <router-link class="routerLink" :to="`/doorphones/${item.intercom_id}`">
          {{ item.address }}
        </router-link>
      </template>
      <template v-slot:item.telephone="{ item }">
        <div v-if="item.telephone">
          <div>
            <v-btn
              large
              outlined
              prepe
              color="aliceblue"
              style="height: 20px"
              class="routerLink"
              @click.prevent="handleClick(item.telephone, $event)"
              @contextmenu.prevent="copyToClipboard(item.telephone)"
            >
              <li>{{ formatPhoneNumber(item.telephone) }}</li>
            </v-btn>
          </div>
        </div>
      </template>
      <template v-slot:item.car_number="{ item }">
          <div v-for="(number, index) in item.car_number" :key="index">
            {{ number }}
          </div>
      </template>
      <template v-slot:item.fio="{ item }">
        {{ item.surname }} {{ item.name }} {{ item.patronymic }}
      </template>
      <template v-slot:item.status="{ item }">
        <div v-if="item.status">
          <!--v-if="roleName === 'admin' && 'admin-engineer'"-->
          <div v-if="roleName !== 'call-center'">
            <v-tooltip v-if="$checkPermission('block_abonent') | $checkPermission('unlock_abonent')" bottom >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="$checkPermission('block_abonent') | $checkPermission('unlock_abonent')"
                  v-bind="attrs"
                  v-on="on"
                  color="primary darken-1"
                  text
                  :aria-disabled="item.status === 'D'"
                >
                  <v-icon x-small :color="(item.status === 'A') ? 'green' : (item.status === 'B') ? 'yellow' : 'red'" >
                    mdi-checkbox-blank-circle
                  </v-icon>
                </v-btn>
              </template>
              <span v-if="item.status === 'A'">Активен</span>
              <span v-if="item.status === 'B'">Заблокирован</span>
              <span v-if="item.status === 'D'">Удален</span>
            </v-tooltip>
          </div>
          <div v-else>
            <p v-if="item.status === 'A'" style="color: green;">Активен</p>
            <p v-if="item.status === 'B'" style="color: chocolate;">Заблокирован</p>
            <p v-if="item.status === 'D'" style="color: red;" >Удален</p>
          </div>
        </div>
      </template>
      <template v-slot:item.action="{ item }">
        <v-row class="flex-nowrap" justify="center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="$checkPermission('simple_update_abonent')"
                icon
                text
                tile
                small
                :disabled="!barrier.device_id"
                v-bind="attrs"
                v-on="on"
                class="btn__icon pa-0"
                width="18"
                height="18"
                @click.stop="$set(dialog, item.id, true)"
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
              <v-dialog v-model="dialog[item.id]" max-width="800" content-class="dialog-border-radius">
                <BaseEditAbonent
                  :active.sync="dialog[item.id]"
                  @close="$set(dialog, item.id, false)"
                  :id="item.id"
                  message="Редактирование абонента"
                  :response-cars="responseCars"
                  :attPopupEditContent="JSON.parse(JSON.stringify(item))"
                  @submit="updateListAbonents()"
                  icon="mdi-pencil-outline"
                />
              </v-dialog>
            </template>
            <span>Редактировать</span>
          </v-tooltip>
        </v-row>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BaseTextField from '../../../BaseTextField';
import BaseEditAbonent from '../../../BaseEditAbonent';
import cp1251Encode from '@/mixins/cp1251Encode';

export default {
  name: 'ListAbonents',
  mixins: [cp1251Encode],
  components: { BaseTextField, BaseEditAbonent },
  props: {
    barrier: {
      type: Object,
      required: true,
    },
    responseCars: Array,
  },
  data () {
    return {
      isCreated: true,
      lastCopiedText: null,
      filters: {},
      responseAbonents: [],
      telephoneSearch: '',
      carSearch: '',
      includeAbonents: [],
      dialog: {},
      filterAbonents: {},
      options: {
        page: 1,
        itemsPerPage: 15,
      },
      totalAccounts: 0,
      headersTable: [
        { text: 'id', value: 'id', align: 'center' },
        { text: 'ФИО', value: 'fio', sortable: false, align: 'center' },
        { text: 'Адрес', value: 'address', sortable: false, align: 'center' },
        { text: 'Телефон', value: 'telephone', sortable: false, align: 'center' },
        { text: 'Номер автомобиля', value: 'car_number', sortable: false, align: 'center' },
        { text: 'Статус', value: 'status', sortable: false, align: 'center' },
        { text: 'Комментарий', value: 'comment', sortable: false, align: 'center' },
        { text: '', value: 'action', sortable: false, align: 'center' },
      ],
    };
  },
  watch: {
    options: {
      handler () {
        if (!this.isCreated) {
          this.getData();
        } else {
          this.isCreated = false;
        }
      },
      deep: true,
    },
  },
  created () {
    this.getData();
  },
  computed: {
    ...mapGetters({
      doorphone: 'Doorphone/doorphone',
      roleName: 'roleName',
    }),
  },
  methods: {
    ...mapActions({
      loadAbonents: 'Abonents/loadAbonents',
      getRules: 'Doorphone/getRules',
      loadClients: 'Client/loadClients',
    }),
    async copyToClipboard (telephone) {
      if (this.lastCopiedText === telephone) {
        return;
      }
      try {
        await navigator.clipboard.writeText(telephone);
        this.lastCopiedText = telephone;
        this.$flash_success('Телефон скопирован!');
      } catch (err) {
        this.$flash_danger('Не удалось скопировать номер телефона');
      }
    },
    async getRedirectionClient (telephone, blank) {
      this.filters = {
        ...(telephone && { telephone_v2: telephone }),
      };
      let idClient = null;
      await this.loadClients({
        pagination: 1,
        limit: 1,
        page: 1,
        filters: this.filters,
      })
        .then((data) => {
          this.clients = data.data;
          idClient = this.clients[0].id;
          if (!this.clients[0]) {
            this.$flash_danger('Клиент не найден, проверьте номер телефона.');
          }
        })
        .catch(() => {
          this.$flash_warning('Ошибка при поиске клиента');
        });
      if (idClient) {
        const routeData = this.$router.resolve({ name: 'DetailClient', params: { id: idClient } });
        if (blank) {
          window.open(routeData.href, '_blank');
        } else {
          await this.$router.push({ name: 'DetailClient', params: { id: idClient } });
        }
      }
    },
    handleClick (telephone, event) {
      const isCtrlPressed = event.ctrlKey || event.metaKey; // event.metaKey для Mac (Cmd key)
      this.getRedirectionClient(telephone, isCtrlPressed);
    },
    searchAbonents () {
      this.options.page = 1;

      if (this.telephoneSearch) {
        this.$set(this.filterAbonents, 'telephone', this.telephoneSearch);
      } else {
        this.$delete(this.filterAbonents, 'telephone');
      }

      if (this.carSearch) {
        this.$set(this.filterAbonents, 'car_number', this.carSearch);
      } else {
        this.$delete(this.filterAbonents, 'car_number');
      }

      this.getData();
    },
    formatPhoneNumber (phoneNumber) {
      phoneNumber = phoneNumber.toString();
      const digits = phoneNumber.replace(/\D/g, '');
      return `+${digits.slice(0, 1)} (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9, 11)}`;
    },
    async updateListAbonents () {
      await this.getData()
        .then(() => {
          this.$flash_success('Таблица обновлена!');
        });
    },
    downloadReportPage () {
      const lines = [];
      this.responseAbonents.forEach((item) => {
        let fio = '';
        let carNumber = '';
        if (item.name) {
          fio = item.name;
        } else {
          fio = '';
        }
        if (item.car_number) {
          carNumber = item.car_number;
        } else {
          carNumber = '';
        }
        const line = [
          item.id, item.address, fio, item.telephone,
          carNumber,
        ].join(';');
        lines.push(line);
      });
      const link = document.createElement('a');
      link.href = `data:text/csv;charset=CP1251,${this.encodeCP1251(lines.join('\n'))}`;
      link.download = 'barrier-abonents.csv';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async getData () {
      const doorphoneIds = this.barrier.doorphones.map(doorphone => doorphone.id);

      if (doorphoneIds.length === 0) {
        this.$flash_danger('Нет привязанных домофонов');
        return;
      }
      this.filterAbonents.doorphone_id = doorphoneIds.join(',');

      this.loadAbonents({
        pagination: 1,
        page: this.options.page,
        limit: this.options.itemsPerPage,
        filters: this.filterAbonents,
        include: this.includeAbonents,
      })
        .then((data) => {
          this.responseAbonents = data.abonents;
          this.totalAccounts = data.meta.total;
        })
        .catch((err) => {
          if (err.message.includes('422')) {
            const response = err.response.data;
            for (const input in response) {
              response[input].forEach(error => this.$flash_warning(input + ': ' + error));
            }
          } else {
            this.$flash_warning('Ошибка при загрузке абонентов');
          }
        });
    },
  },
};
</script>

<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.table-custom-header {
  padding: 5px !important;
  font-size: 13px !important;
  max-width: 2%;
  text-overflow: ellipsis;
}
.table-custom-header.wrap-text span {
  white-space: normal;
}
.table-custom-header span {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.border {
  border-radius: 16px;
}
.card-footer {
  background-color: #4C6C93;
  color: white;
  width: 65px !important;
  margin-right: 15px;
  height: 65px !important;
  padding: 5px 16px;
}
.routerLink {
  background: none;
  border: none;
  color: blue;
  text-decoration: none;
  cursor: pointer;
  padding: 0;
  font-size: inherit;
  font-weight: inherit;
}

.routerLink:hover {
  color: darkblue;
  text-decoration: underline;
}

.v-application a {
  color: #434850;
}
.v-application p {
  margin-bottom: 0;
}

.v-text-field-like {
  display: flex;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius: 4px;
  padding: 6px;
  margin-bottom: 0;
  height: 40px;
}

.v-icon-before {
  margin-right: 8px;
}

.text-wrap-nowrap {
  white-space: nowrap;
}

.custom-input {
  width: 350px;
  border: none;
  outline: none;
}
@media screen and (max-width: 600px) {
  .v-text-field-like {
    width: 200px;
  }
}
</style>
